module.exports = __webpack_public_path__ + "static/media/mic-muted-icon.48bc1877.svg";